(function ($) {
  $(document).ready(function () {
    const $section = $('#BlogFilterSection');
    if (!$section.length) return;

    const blogHandle = $section.data('blog-handle');
    const $grid = $('#BlogGrid');
    const $loadMore = $('#LoadMoreBtn');
    const $loading = $('#BlogLoading');
    const currentParams = new URLSearchParams(window.location.search);
    const previewThemeId = currentParams.get('preview_theme_id');
    const PAGE_SIZE = 18;

    let page = 1;
    let activeTag = '';
    let activeLevels = [];
    let isLoading = false;
    let filterRequestId = 0;
    let popularItems = [];
    let popularVisibleCount = PAGE_SIZE;
    let popularMode = false;

    function normalizeLevel(value) {
      return String(value || '').trim().toLowerCase();
    }

    function buildUrl(requestedPage, viewName) {
      let url = `/blogs/${blogHandle}`;
      if (activeTag) url += `/tagged/${encodeURIComponent(activeTag)}`;

      const params = new URLSearchParams({
        view: viewName || 'ajax',
        page: String(requestedPage)
      });
      if (previewThemeId) params.set('preview_theme_id', previewThemeId);
      return `${url}?${params.toString()}`;
    }

    function setLoading(loading, dimGrid) {
      isLoading = loading;
      $loadMore.toggleClass('loading', loading).prop('disabled', loading);
      $loading.toggle(loading);
      if (dimGrid) $grid.css('opacity', loading ? 0.4 : 1);
    }

    function parseResponse(html) {
      const $temp = $('<div>').html(html);
      const $items = $temp.find('.blog-card');
      const totalPages = Number($temp.find('.filter-page-meta').data('total-pages')) || 1;
      const matches = [];

      $items.each(function () {
        const level = normalizeLevel($(this).attr('data-kuchenlevel'));
        if (!activeLevels.length || activeLevels.includes(level)) matches.push(this);
      });

      return { items: $items, matches: matches, totalPages: totalPages };
    }

    function requestPage(requestedPage, viewName) {
      return $.ajax({
        url: buildUrl(requestedPage, viewName),
        method: 'GET',
        dataType: 'html'
      });
    }

    function fetchAllPages() {
      const requestId = ++filterRequestId;

      return requestPage(1, 'filter').then(function (firstHtml) {
        const first = parseResponse(firstHtml);
        const allMatches = first.matches.slice();
        const requests = [];

        for (let requestedPage = 2; requestedPage <= first.totalPages; requestedPage++) {
          requests.push(requestPage(requestedPage, 'filter'));
        }

        if (!requests.length) return allMatches;

        return $.when.apply($, requests).then(function () {
          if (requestId !== filterRequestId) return [];

          const responses = requests.length === 1 ? [arguments] : Array.from(arguments);
          responses.forEach(function (response) {
            const html = Array.isArray(response) ? response[0] : response;
            const parsed = parseResponse(html);
            Array.prototype.push.apply(allMatches, parsed.matches);
          });

          return allMatches;
        });
      });
    }

    function popularityScore(item) {
      const $item = $(item);
      const title = String($item.attr('data-recipe-title') || $item.find('.blog-title').text() || '').toLowerCase();
      const tags = String($item.attr('data-recipe-tags') || '').toLowerCase();
      const text = `${title} ${tags}`;
      let score = 0;

      const groups = [
        { score: 120, terms: ['pizza', 'pasta', 'spaghetti', 'lasagne', 'burger', 'pfannkuchen', 'pancake'] },
        { score: 105, terms: ['curry', 'risotto', 'tiramisu', 'schokolade', 'schoko', 'kuchen', 'brot'] },
        { score: 90, terms: ['salat', 'suppe', 'smoothie', 'kartoffel', 'apfel', 'nudel', 'bowl', 'müsli', 'granola'] },
        { score: 75, terms: ['hähnchen', 'rind', 'lachs', 'gemüse', 'vegan', 'vegetarisch', 'dessert'] },
        { score: 55, terms: ['frühstück', 'schnell', 'einfach', 'gesund', 'protein', 'low carb'] }
      ];

      groups.forEach(function (group) {
        group.terms.forEach(function (term) {
          if (text.includes(term)) score += group.score;
        });
      });

      if (normalizeLevel($item.attr('data-kuchenlevel')) === 'leicht') score += 18;
      return score;
    }

    function sortByPopularity(items) {
      return items
        .map(function (item, index) {
          return { item: item, score: popularityScore(item), index: index };
        })
        .sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return a.index - b.index;
        })
        .map(function (entry) { return entry.item; });
    }

    function renderPopularItems() {
      $grid.empty();
      popularItems.slice(0, popularVisibleCount).forEach(function (item) {
        $grid.append(item);
      });
      $loadMore.toggle(popularVisibleCount < popularItems.length);
    }

    function fetchPopularRecipes() {
      popularMode = true;
      popularVisibleCount = PAGE_SIZE;
      $('.no-result').remove();
      setLoading(true, true);

      fetchAllPages()
        .done(function (items) {
          popularItems = sortByPopularity(items);
          if (!popularItems.length) {
            $grid.html('<p class="no-result">Keine passenden Rezepte gefunden.</p>');
            $loadMore.hide();
            return;
          }
          renderPopularItems();
        })
        .fail(function () {
          $grid.html('<p class="no-result">Die Rezepte konnten gerade nicht geladen werden.</p>');
          $loadMore.hide();
        })
        .always(function () {
          setLoading(false, true);
        });
    }

    function fetchArticles(requestedPage, append) {
      if (isLoading) return;
      $('.no-result').remove();
      popularMode = false;
      popularItems = [];
      setLoading(true, !append);

      if (activeLevels.length) {
        fetchAllPages()
          .done(function (items) {
            $grid.empty();
            page = 1;

            if (!items.length) {
              $grid.html('<p class="no-result">Keine passenden Rezepte gefunden.</p>');
            } else {
              items.forEach(function (item) { $grid.append(item); });
            }

            $loadMore.hide();
          })
          .fail(function () {
            $grid.html('<p class="no-result">Die Rezepte konnten gerade nicht geladen werden.</p>');
            $loadMore.hide();
          })
          .always(function () {
            setLoading(false, true);
          });
        return;
      }

      requestPage(requestedPage, 'ajax')
        .done(function (html) {
          const parsed = parseResponse(html);

          if (!append) {
            $grid.empty();
            page = 1;
          }

          parsed.matches.forEach(function (item) { $grid.append(item); });

          if (!append && !parsed.matches.length) {
            $grid.html('<p class="no-result">Keine passenden Rezepte gefunden.</p>');
          }

          if (parsed.items.length < PAGE_SIZE) $loadMore.hide();
          else $loadMore.show();
        })
        .fail(function () {
          if (!append) {
            $grid.html('<p class="no-result">Die Rezepte konnten gerade nicht geladen werden.</p>');
          }
          $loadMore.hide();
        })
        .always(function () {
          setLoading(false, true);
        });
    }

    function refreshRecipes() {
      page = 1;
      if (!activeTag && !activeLevels.length) fetchPopularRecipes();
      else fetchArticles(1, false);
    }

    $section.on('click', '.filter-tag', function (event) {
      event.preventDefault();
      filterRequestId += 1;
      $('.filter-tag').removeClass('active');
      $(this).addClass('active');
      activeTag = $(this).data('tag') || '';
      refreshRecipes();
    });

    $section.on('change', '.filter-level', function () {
      filterRequestId += 1;
      activeLevels = $('.filter-level:checked').map(function () {
        return normalizeLevel($(this).val());
      }).get();
      refreshRecipes();
    });

    $section.on('click', '.filter-mobie', function () {
      $(this).closest('.tag-custom').toggleClass('is-open');
    });

    $loadMore.on('click', function () {
      if (isLoading || activeLevels.length) return;

      if (popularMode) {
        popularVisibleCount += PAGE_SIZE;
        renderPopularItems();
        return;
      }

      page += 1;
      fetchArticles(page, true);
    });

    fetchPopularRecipes();
  });
})(jQuery);
